module.exports = __webpack_public_path__ + "img/reason1.c23f66b8.png";